(() => {
  const root = document.querySelector('[data-product-finder]');
  if (!root) return;
  const stage = root.querySelector('[data-finder-stage]');
  const results = root.querySelector('[data-finder-results]');
  const grid = root.querySelector('[data-finder-grid]');
  const label = root.querySelector('[data-finder-label]');
  const bar = root.querySelector('[data-finder-progress]');
  const escapeHTML = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  }[char]));
  const currency = document.body.dataset.currency || 'CAD';
  const questionLabel = root.dataset.questionLabel || 'Question';

  let products = [];
  try {
    const primary = JSON.parse(root.querySelector('[data-finder-products]')?.textContent || '{"products":[]}').products || [];
    const extras = [...root.querySelectorAll('[data-finder-extra]')]
      .map((script) => {
        try { return JSON.parse(script.textContent); } catch (_error) { return null; }
      })
      .filter(Boolean);
    products = [...new Map([...primary, ...extras].filter((product) => product?.handle).map((product) => [product.handle, product])).values()];
  } catch (_error) {
    products = [];
  }

  const questions = [
    { title: 'Who is this piece for?', arabic: 'لِمَن هذه القطعة؟', key: 'purpose', options: [['self', 'For me', 'قطعة إلي'], ['gift', 'A meaningful gift', 'هدية بمعنى'], ['home', 'For our home', 'للبيت']] },
    { title: 'What are you drawn to?', arabic: 'شو بدك تحمل من فلسطين؟', key: 'category', options: [['wear', 'Something to wear', 'كوفية أو لبس'], ['accessory', 'A daily accessory', 'شنطة أو إكسسوار'], ['decor', 'Heritage for the home', 'تطريز وديكور'], ['pantry', 'A taste of home', 'بهارات ومونة']] },
    { title: 'Which feeling fits you?', arabic: 'أي طابع أقرب إلك؟', key: 'style', options: [['traditional', 'Deeply traditional', 'تراثي واضح'], ['bold', 'Bold and expressive', 'قوي ولافت'], ['minimal', 'Quiet and modern', 'هادئ وعصري']] },
    { title: 'Choose your budget', arabic: 'حدّد ميزانيتك', key: 'budget', options: [['under25', `Under $25 ${currency}`, 'أقل من 25$'], ['25to50', `$25–$50 ${currency}`, 'من 25$ إلى 50$'], ['over50', `$50+ ${currency}`, 'أكثر من 50$']] }
  ];
  const answers = {};
  let step = 0;

  function showQuestion() {
    results.hidden = true;
    stage.hidden = false;
    const question = questions[step];
    label.textContent = `${questionLabel} ${step + 1} of ${questions.length}`;
    bar.style.width = `${((step + 1) / questions.length) * 100}%`;
    stage.innerHTML = `<div class="finder-question"><p dir="rtl">${escapeHTML(question.arabic)}</p><h3>${escapeHTML(question.title)}</h3><div class="finder-options">${question.options.map((option, index) => `<button type="button" data-answer="${escapeHTML(option[0])}"><span>0${index + 1}</span><strong>${escapeHTML(option[1])}</strong><small dir="rtl">${escapeHTML(option[2])}</small></button>`).join('')}</div></div>`;
    stage.querySelectorAll('[data-answer]').forEach((button) => button.addEventListener('click', () => {
      answers[question.key] = button.dataset.answer;
      if (step < questions.length - 1) {
        step += 1;
        showQuestion();
      } else {
        recommend();
      }
    }));
  }

  function score(product) {
    const text = `${product.title} ${product.type} ${(product.tags || []).join(' ')}`.toLowerCase();
    let value = 0;
    if (answers.purpose === 'gift' && /(gift|accessory|necklace|bracelet|wallet|pin|bookmark)/.test(text)) value += 4;
    if (answers.purpose === 'home' && /(home|wall|decor|tissue|spice|hanging|sculpture)/.test(text)) value += 5;
    if (answers.category === 'wear' && /(keffiyeh|kufiya|hoodie|shirt|shawl|scarf|clothing)/.test(text)) value += 7;
    if (answers.category === 'accessory' && /(bag|tote|pouch|wallet|necklace|bracelet|ring|pin|accessory)/.test(text)) value += 7;
    if (answers.category === 'decor' && /(wall|decor|hanging|tissue|wood|plaster|tatreez|embroider)/.test(text)) value += 7;
    if (answers.category === 'pantry' && /(spice|food|zaatar|sumac|duqqa|kabsa|falafel)/.test(text)) value += 9;
    if (answers.style === 'traditional' && /(traditional|heritage|tatreez|embroider|keffiyeh|kufiya)/.test(text)) value += 4;
    if (answers.style === 'bold' && /(flag|map|color|statement|watermelon|red|gold)/.test(text)) value += 3;
    if (answers.style === 'minimal' && /(minimal|black|silver|simple|modern)/.test(text)) value += 3;
    if (answers.budget === 'under25' && product.price <= 2500) value += 6;
    if (answers.budget === '25to50' && product.price >= 2500 && product.price <= 5000) value += 6;
    if (answers.budget === 'over50' && product.price > 5000) value += 6;
    return value;
  }

  function recommend() {
    const chosen = products.map((product) => ({ ...product, score: score(product) }))
      .sort((a, b) => b.score - a.score).slice(0, 3);
    stage.hidden = true;
    results.hidden = false;
    label.textContent = 'Your results';
    bar.style.width = '100%';
    if (!chosen.length) {
      grid.innerHTML = '<div class="finder-empty"><h4>Your collection is still being prepared.</h4><p>Please explore all Palestinian pieces while products sync with the finder.</p></div>';
      return;
    }
    grid.innerHTML = chosen.map((product, index) => `<a class="finder-product" href="${escapeHTML(product.url)}"><div>${product.image ? `<img src="${escapeHTML(product.image)}" loading="lazy" alt="${escapeHTML(product.title)}">` : '<span class="finder-no-image">فلسطين</span>'}<b>0${index + 1}</b></div><small>Chosen for you</small><h4>${escapeHTML(product.title)}</h4><strong>${escapeHTML(product.priceText)}</strong><span>View piece ↗</span></a>`).join('');
  }

  function reset() {
    step = 0;
    Object.keys(answers).forEach((key) => delete answers[key]);
    showQuestion();
  }
  root.querySelector('[data-finder-reset]')?.addEventListener('click', reset);
  root.querySelector('[data-finder-again]')?.addEventListener('click', reset);
  showQuestion();
})();
